export default "<p>\r\n  footer works!\r\n</p>\r\n";